export const AuditAction = {
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
    START_TABLE: 'START_TABLE',
    STOP_TABLE: 'STOP_TABLE',
    PAUSE_TABLE: 'PAUSE_TABLE',
    RESUME_TABLE: 'RESUME_TABLE'
} as const

export type AuditAction = typeof AuditAction[keyof typeof AuditAction]

export const EntityType = {
    USER: 'USER',
    TABLE: 'TABLE',
    SESSION: 'SESSION',
    TARIFF: 'TARIFF',
    BOOKING: 'BOOKING',
    PLAYER_ASSIGNMENT: 'PLAYER_ASSIGNMENT'
} as const

export type EntityType = typeof EntityType[keyof typeof EntityType]

export interface AuditLog {
    id: number
    entityType: EntityType
    entityId: number
    action: AuditAction
    userId?: number
    userName?: string
    timestamp: string
    changes?: Record<string, any>
    oldValue?: string
    newValue?: string
    ipAddress?: string
    userAgent?: string
}

// Request DTOs
export interface FetchAuditLogsRequest {
    page?: number
    size?: number
    entityType?: EntityType
    entityId?: number
    userId?: number
    action?: AuditAction
    startDate?: string
    endDate?: string
}